import React from 'react'
import Typography from '@mui/material/Typography'
import moment from 'moment'
import ChatAttachmentMedia from './chat-attachment-media'
import { sanitizeHtmlMessage } from './sanitize-html-message'

const MESSAGE_ORIGIN_CHATBOT = 5
const MESSAGE_ORIGIN_AUTOMATIC = 4
const MESSAGE_ORIGIN_AGENT = 1

const BUBBLE_STYLE_BY_ORIGIN = {
  [MESSAGE_ORIGIN_CHATBOT]: { backgroundColor: '#f3e5f5', align: 'right' },
  [MESSAGE_ORIGIN_AUTOMATIC]: { backgroundColor: '#e0f2f1', align: 'right' },
  [MESSAGE_ORIGIN_AGENT]: { backgroundColor: '#e3f2fd', align: 'right' },
}
const DEFAULT_BUBBLE_STYLE = { backgroundColor: '#f5f5f5', align: 'left' }

const ChatMessageBubble = ({ item }) => {
  const style = BUBBLE_STYLE_BY_ORIGIN[item.messageorigin] || DEFAULT_BUBBLE_STYLE
  const align = style.align
  const isRight = align === 'right'

  return (
    <div style={{ display: 'flex', justifyContent: isRight ? 'flex-end' : 'flex-start', marginBottom: 12 }}>
      <div style={{ maxWidth: '70%', backgroundColor: style.backgroundColor, borderRadius: 12, padding: '8px 12px' }}>
        <Typography variant="caption" color="textSecondary" align={align} style={{ display: 'block', marginBottom: 4 }}>
          {item.sendername} — {moment(item.createdat).format('DD/MM/YYYY HH:mm')}
        </Typography>
        {item.attachment != null
          ? <ChatAttachmentMedia item={item} align={align} />
          : <Typography variant="body1" align={align}>{item.message != null ? sanitizeHtmlMessage(item.message) : null}</Typography>}
      </div>
    </div>
  )
}

export default ChatMessageBubble
